export const signIn = (payload: { phone: string; password: string }) => ({
    type: '@saga/SIGN_IN',
    payload,
});
